import { servicesAdmins } from 'services';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';
import { QueryConfig } from 'react-query';
import { TQueryDefWrapper } from 'types/network';
import { TGetAdminActivityLogDetailResponse } from 'types/entities/admin-activity-logs';

const useAdminActivityLogDetail = (
    id: string,
    arg0?: QueryConfig<
        TQueryDefWrapper<TGetAdminActivityLogDetailResponse>,
        string
    >,
) => {
    return useQueryHookWrapper<
        TQueryDefWrapper<TGetAdminActivityLogDetailResponse>,
        string,
        { id: string }
    >({
        queryKey: `admin-activity-log-detail`,
        queryFn: servicesAdmins.getAdminActivityLogDetail,
        queryConfig: arg0,
        values: { id },
    });
};

export default useAdminActivityLogDetail;
